export default __webpack_public_path__ + "static/media/footlocker-logo.f08cc12a.png";